import { inject } from "vue";
import { WS_SYMBOL } from "../injection-symbols";
import type { WebSocketService } from "../web-socket-service";

export const useWebsocket = (): WebSocketService | undefined => {
	return inject(WS_SYMBOL);
};

export function useWebsocketOrThrow(): WebSocketService {
	const service = inject(WS_SYMBOL);
	if (service == null) {
		throw new Error("ws not in context");
	}

	return service;
}
